export const verificationStatuses = {
    VERIFIED: "Verified",
    NOT_VERIFIED: "Not Verified",
    DENIED: "Denied",
}

export const paymentStatuses = {
    PAID: "Paid",
    UNPAID: "Unpaid",
    NOT_VERIFIED: "Not Verified",
}